var map = {
	"./amersfoort-logo.png": "0ff1",
	"./culemborg-logo.png": "4383",
	"./hendrik-ido-ambacht-logo.png": "3e70",
	"./leiderdorp-logo.png": "517e",
	"./tholen-logo.png": "bca0",
	"./waalre-logo.png": "4edc",
	"./wijk-bij-duurstede-logo.png": "9885",
	"./zaltbommel-logo.png": "7c47"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0565";